
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12.717","height":"17.207"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 729","fill":"#464646"}},[_c('path',{attrs:{"data-name":"Path 764","d":"M5.757 16.958L.251 11.452A.85.85 0 01.851 10h11.012a.85.85 0 01.6 1.452l-5.506 5.506a.85.85 0 01-1.2 0z"}}),_c('path',{attrs:{"data-name":"Path 764","d":"M6.96.249l5.506 5.506a.85.85 0 01-.6 1.452H.854a.85.85 0 01-.6-1.452L5.76.249a.85.85 0 011.2 0z","opacity":".25"}})])])
          )
        }
      }
    